const BoostCheckoutRedirect = () => {
  window.location.replace(
    `${process.env.REACT_APP_DOMAIN}/boost-pricing${window.location.search}`
  );
  return null;
};

export default BoostCheckoutRedirect;
